import React from 'react'
import { useDispatch } from 'react-redux';
import { setErrorButton } from '../../store/buttonSlice';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default function GoalsContent({ checkboxes, setCheckboxes, error, setDisabled, setError }) {

    const dispatch = useDispatch();
    const handleCheckboxChange = (checkboxId, isChecked) => {

        setCheckboxes(prevCheckboxes => {
            const updatedCheckboxes = prevCheckboxes.map(checkbox =>
                checkbox.id === checkboxId ? { ...checkbox, checked: isChecked } : checkbox
            );

            const anyChecked = updatedCheckboxes.some(checkbox => checkbox.checked);
            setDisabled(!anyChecked);
            dispatch(setErrorButton(false))
            setError(false)
            return updatedCheckboxes;
        });
    };

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const checkboxesData = checkboxes ? checkboxes : [
        {
            id: '0',
            checked: false,
            title: 'Purchases',
            text: "Increase amount of orders",
            img: 'Shopify.svg',
        },
        {
            id: '2',
            checked: false,
            title: 'ROAS',
            text: "Boost return on<br> ad spend",
            img: 'g2.svg',
        },
        {
            id: '1',
            checked: false,
            title: 'CPA',
            text: "Lower cost per action",
            img: 'g2.svg',
        },
        {
            id: '3',
            checked: false,
            title: 'CTR',
            text: "Improve<br>click through rate",
            img: 'g2.svg',
        }
    ]

    const socials = queryParams.get('ad-channels-value') ? queryParams.get('ad-channels-value').split(',') : [];

    const instagram = queryParams.get('platforms-value') === 'Instagram2.svg' && socials.some((social) => social === 'instagram');
    const facebook = queryParams.get('platforms-value') === 'Facebook.svg' && socials.some((social) => social ===  "Facebook");
    const tiktok = queryParams.get('platforms-value') === 'TikTok.svg' && socials.some((social) => social ===  "TikTok");

    return (

        <>
            {checkboxesData && checkboxesData.map((checkbox, index) => (
                <div
                    key={checkbox.id}
                    checked={checkbox.checked}
                    onClick={() => handleCheckboxChange(checkbox.id, !checkbox.checked)}

                    className={`goals-item ${checkbox.checked ? 'checked' : undefined}`}
                >
                    <div className={`goals-item__checked ${error ? 'error' : ""} ${checkbox.checked ? 'checked' : ""}`}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.30859 6.00764L4.8727 8.31534L10.0009 3.69995" stroke="white" stroke-width="1.6" stroke-linecap="round" />
                        </svg>
                    </div>
                    {index === 0 ?
                        (
                            <> <div className="goals-item__images">
                          
                                {queryParams.get('platforms-value') && !instagram && !facebook && !tiktok  && (<img  style={{background: '#fff', border: '1rem solid #F2F4F6'}} src={process.env.PUBLIC_URL + `/img/platform-icons/${queryParams.get('platforms-value')}`} alt="" />)}
                                {socials.length > 0 && socials.map((social) => (
                                    <img key={social} style={{ border: social === 'Google' ? '1rem solid #F2F4F6' : '', background: social === 'Google' ? '#FFF' : '' }} src={process.env.PUBLIC_URL + `/img/SVG_Goals/${social}.svg`} alt="" />
                                ))}
                                </div>
                            </>

                        ) : (<div className="goals-item__images">
                            {socials.length > 0 ? (socials.map((social, index) => (
                                <img style={{ border: social == 'Google' ? '1rem solid #F2F4F6' : '', background: social == 'Google' ? '#FFF' : '' }} src={process.env.PUBLIC_URL + `/img/SVG_Goals/${social}.svg`} alt="" />
                            ))) : (
                                <>

                                    <img style={{ border: '1rem solid #F2F4F6', background: '#fff' }} src={process.env.PUBLIC_URL + `/img/SVG_Goals/Google.svg`} alt="" />
                                    <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/TikTok.svg`} alt="" />
                                    <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/Facebook.svg`} alt="" />
                                    <img src={process.env.PUBLIC_URL + `/img/SVG_Goals/Instagram.svg`} alt="" />
                                </>
                            )}

                        </div>
                        )
                    }
                    <div>
                        <h4>{checkbox.title}</h4>
                        <p dangerouslySetInnerHTML={{ __html: checkbox.text }}></p>
                    </div>
                </div>
            ))}
        </>
    )
}
